<template>
<div class="container unprint" ref="container">
  <div class="row">
    <div class="slopePage__title">
      <b>Альбомы и инструкции по материалам и монтажу</b>
    </div>
  </div>
  <div class="row addons">
    <div class="col-lg-4 col-12 col-sm-6 col-md-6 addons__item" v-for="(item, i) in albums"
         :key="i">
      <a :href="item.link" class="addons__link" target="_blank">
        <img src="@/assets/img/download.svg" alt="downlad" class="addons__link-img">
        {{ item.name }}
      </a>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props: {
    albums: Array,
  },
  data() {
    return {
      links: [],
    };
  },
  components: {
  },
  mounted() {
    // this.links = this.albums;
  },
  computed: {
  },
};
</script>

<style lang="sass" scoped>
</style>
